export function ImgCompact( { size = 12 }: { size?: number } ) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path d="M8 2v5M8 14v-5M2 8h5M14 8h-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
};